import { useEffect, useState } from "react";

/** Chrome/Android meldet "beforeinstallprompt" oft schon vor dem ersten Rendern, deshalb wird das
 * Ereignis beim Laden des Moduls abgefangen (Import in main.tsx) und hier aufbewahrt. */
interface InstallAufforderung extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

let aufforderung: InstallAufforderung | null = null;
const zuhoerer = new Set<() => void>();
const melden = () => zuhoerer.forEach((f) => f());

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  aufforderung = e as InstallAufforderung;
  melden();
});
window.addEventListener("appinstalled", () => {
  aufforderung = null;
  melden();
});

export type Geraet = "ios" | "android" | "andere";

export function geraet(): Geraet {
  const ua = navigator.userAgent;
  // iPadOS meldet sich als Mac, hat aber Touch.
  if (/iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return "ios";
  if (/Android/.test(ua)) return "android";
  return "andere";
}

export function laeuftAlsApp(): boolean {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

/** Liefert eine Funktion, die den Installationsdialog des Browsers öffnet, falls er einen anbietet. */
export function useInstallieren(): (() => Promise<void>) | null {
  const [, neuZeichnen] = useState(0);
  useEffect(() => {
    const f = () => neuZeichnen((n) => n + 1);
    zuhoerer.add(f);
    return () => {
      zuhoerer.delete(f);
    };
  }, []);
  if (!aufforderung) return null;
  const a = aufforderung;
  return async () => {
    await a.prompt();
    await a.userChoice;
    aufforderung = null;
    melden();
  };
}
